import React, {useState, useEffect, useCallback} from 'react'
import {Descriptions, Form, Input, Button} from 'antd'
import {connect} from "dva";
import {component_tool, framework_tool, utils_tool} from "@/tool";

const {WizSpin, WizCard} = component_tool
const {WizContainer, modelUtils} = framework_tool;
const {Session} = utils_tool

import {AuditForm} from './components'

import {personStateEnum} from '../util'

import './index.less'

const typeEnum = [
  {
    type: 'Old',
    title: (data) => {
      const callback = () => {
        console.log('data =========>', data)
        wizNotice.warn('功能开发中，敬请期待。');
      }

      return <p>旧账号(需合并账号)&nbsp;&nbsp;&nbsp;&nbsp;<Button onClick={callback}>查看数据</Button></p>
    },
  },
  {
    type: 'New',
    title: '新账号(合并后保留账号)',
  },
]

class Index extends WizContainer {
  componentName = 'AccountConsolidationDetail';

  constructor(props) {
    super(props);
    const {location} = props


    const {record} = location
    let id;
    if ([undefined, null].indexOf(record?.id) === -1) {
      id = record?.id;
      Session.set('accountConsolidationRecordDetail', id)
    } else {
      id = Session.get('accountConsolidationRecordDetail');
    }
    this.id = id;
    this.state = {}
  }

  _componentDidMount() {
    this.init()
  }

  propsAndStateOnChange = {
    detail: this._detail.bind(this),
    audit: this._audit.bind(this),
  }

  init = () => {
    this.doAction({
      path: 'accountConsolidationRecord/getInfoById',
      payload: {
        key: 'accountConsolidationRecord@getInfoById',
        apiParams: {id: this?.id}
      },
    })
  }

  _detail(nextProps, nextState) {
    const res = nextProps?.detail;

    let {success, data, msg} = res || {}
    if (!success) {
      wizNotice.error(msg || '系统运行繁忙,请稍后再试');
      return false;
    }
    nextState.data = data;
    return true;
  }

  submit = (data) => {
    console.log('提交  =====>', data)

    this.doAction({
      path: 'accountConsolidationRecord/audit',
      payload: {
        key: 'accountConsolidationRecord@audit',
        apiParams: {
          ...data
        }
      },
    })
  }

  _audit(nextProps, nextState) {
    const res = nextProps?.audit;

    let {success, data, msg} = res || {}
    if (!success) {
      wizNotice.error(msg || '系统运行繁忙,请稍后再试');
      return false;
    }
    wizNotice.success(msg);
    this.init();
    return true;
  }

  _render() {
    const {data} = this.state
    const {accountConsolidationRecordLoading} = this.props;
    const {fullName, submitTime} = data || {};

    return (
      <div className={'accountConsolidationRecord-container'}>
        <WizSpin spinning={accountConsolidationRecordLoading}>
          <WizCard title={'账号合并记录'}>
            <Descriptions title="申请信息" column={2}>
              <Descriptions.Item label="申请时间">{submitTime || '暂无'}</Descriptions.Item>
              <Descriptions.Item label="申请人">{fullName || '暂无'}</Descriptions.Item>
            </Descriptions>
            <Descriptions title="账号合并信息">
              <Descriptions.Item>
                {
                  typeEnum.map((item, index) => {
                    const {type, title} = item
                    const personInfo = data?.[`personInfo${type}`] || {}
                    const {personId, fullName, userName, state, identityList} = personInfo

                    return (
                      <Descriptions
                        key={personId}
                        title={typeof title === 'function' ? title(personInfo) : title}
                        column={3}
                      >
                        <Descriptions.Item label="姓名">{fullName}</Descriptions.Item>
                        <Descriptions.Item label="账号">{userName}</Descriptions.Item>
                        <Descriptions.Item label="账号状态">{personStateEnum[state] || '未知'}</Descriptions.Item>
                        <Descriptions.Item label="任职" span={3}>
                          {
                            identityList
                              ?.map(identity => {
                                let {orgName, positionName} = identity || {}
                                return `${orgName}-${positionName}`
                              })
                              .join('、') || '暂无任职'
                          }
                        </Descriptions.Item>
                      </Descriptions>
                    )
                  })
                }
              </Descriptions.Item>
            </Descriptions>
          </WizCard>
          <WizCard title={'审核信息'}>
            <AuditForm data={data} submit={this.submit}/>
          </WizCard>
        </WizSpin>
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  const {accountConsolidationRecord} = state;

  const detail = modelUtils.getModelEntity(accountConsolidationRecord, 'accountConsolidationRecord@getInfoById');
  const audit = modelUtils.getModelEntity(accountConsolidationRecord, 'accountConsolidationRecord@audit');

  const load = modelUtils.getLoadingState(state, ['accountConsolidationRecord']);

  return {
    detail,
    audit,
    ...load,
  }
};

// export default connect(mapStateToProps)(Form.create()(Index));
export default connect(mapStateToProps)(Index);
// export default Form.create()(Index)
// export default Index
